import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectsReviewsBulkCreationMutation({ projectId }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(
        `/projects/${projectId}/reviews/bulk_creations`,
      );

      return response.data;
    },
    onSuccess: () => {
      ['latestVersion', 'projectPersonnel', 'signatureStatus'].forEach(
        (queryKeySegment) =>
          queryClient.invalidateQueries([
            'projects',
            projectId,
            queryKeySegment,
          ]),
      );
    },
  });
}
